unit Zeitbuchung;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,  WEBLib.Storage,
  Vcl.Graphics, WEBLib.Buttons, WEBLib.Grids, Vcl.Grids, WEBLib.DBCtrls, XData.Web.Connection,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.DB, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCCustomPicker,
  VCL.TMSFNCComboBox, Vcl.Imaging.pngimage, XData.Web.Client, Bcl.Utils,
  VCL.TMSFNCToolBar, Vcl.Imaging.GIFImg, VCL.TMSFNCDateTimePicker, WebBasis, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCBitmapContainer   ;

type
  TfrmZeitbuchung = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbTau: TLabel;
    btnNavPrev: TTMSFNCToolBarButton;
    btnNavNext: TTMSFNCToolBarButton;
    btnNavInfo: TTMSFNCToolBarButton;
    respGrid: TResponsiveGrid;
    dtFilterDatum: TDateTimePicker;
    cbxFilterDatum: TCheckBox;
    tabZBuchung: TXDataWebDataSet;
    tabZBuchungZEITSTEMPEL: TStringField;
    tabZBuchungGRUND: TStringField;
    tabZBuchungFARBE: TStringField;
    tabZBuchungID_ZBUCHUNG: TIntegerField;
    tabZBuchungID_ANWABW: TIntegerField;
    btnKommt: TButton;
    btnGeht: TButton;
    btnGehtP: TButton;
    btnKommtP: TButton;
    //
    [async] procedure Daten_Laden( aID : Integer ); async;
    [async] procedure ErzeugeItems; async;
    [async] procedure Form_Uebersetzen; async;
    [async] procedure WebFormShow(Sender: TObject); async;
    [async] procedure btnGehtClick(Sender: TObject); async;
    //
    procedure WebFormCreate(Sender: TObject);
    procedure Do_DatenLaden(Sender: TObject);
    procedure btnNavInfoClick(Sender: TObject);
    procedure respGridItemDblClick(Sender: TObject; Index: Integer);
    procedure dtFilterDatumChange(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);



  private
    bFirst : Boolean;
    iRec_Von : Integer;
    iRec_Bis : Integer;
    iID_Akt  : Integer;
    sSortFeldName : String;
    procedure Opt_Speichern;
    procedure Opt_Laden;

  public


  protected procedure LoadDFMValues; override; end;

var frmZeitbuchung: TfrmZeitbuchung;

const cFormZeitbuchung = 'ZEITBUCHUNG_';

implementation

{$R *.dfm}

uses UnitMain, GlobalWeb,  SpediFucsDatenmodul, TourEdit;

//====================================================================================================================//

procedure TfrmZeitbuchung.btnGehtClick(Sender: TObject);
var iGrund : Integer;
    sText, sSQL, sZP : String;
    aModalRsult : TModalResult;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
begin
  inherited;

  iGrund := TButton(Sender).Tag ;
  sText  := TButton(Sender).Caption ;

  aModalRsult := await(TModalResult, MessageDlgAsync(sText+' - Buchung anlegen ?', mtConfirmation, [mbYes, mbNo]));
  If aModalRsult <> mrYes then Exit;

  sZP := FormatDateTime('dd.mm.yyyy hh:nn:ss', Now);

  sSQL := 'INSERT INTO ZBUCHUNG(ID_MITARBEITER,ID_ANWABW, BU_ART, INS_USER, ZEITSTEMPEL) '
         +' VALUES('+frmMainForm.BenutzerMaNr+','+IntToStr(iGrund)+', 2,'
         +cH+frmMainForm.User_Account+cH+', '+cH+sZP+cH+')';

  sSQL := await(  Crypt( sSQL ) );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.ExecSQL', [ sSQL ] ));
  ClientConn.Free;

  await( Daten_Laden(0) );

end;

//====================================================================================================================//

procedure TfrmZeitbuchung.btnNavInfoClick(Sender: TObject);
var iID : Integer;
begin

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  iID := 0;
  Daten_Laden(iID);

end;

//====================================================================================================================//

procedure TfrmZeitbuchung.Opt_Laden;
var sDat, sVon, sBis : String;
    iVon, iBis : Integer;
begin

  //console.log('');
  //console.log('TfrmTau.Opt_Laden');
  cbxFilterDatum.Checked := SToB( TLocalStorage.GetValue( cFormZeitbuchung +'DATUM_FILTER_EIN' ) );

  sDat := TLocalStorage.GetValue( cFormZeitbuchung +'DATUM_FILTER' );
  If sDat='' then
       dtFilterDatum.DateTime := Date
  Else dtFilterDatum.DateTime := StrToDateTime(sDat);

  self.iID_Akt := StrToIntDef( TLocalStorage.GetValue( cFormZeitbuchung+'ID_AKT' )  , 0);

  sVon := TLocalStorage.GetValue( cFormZeitbuchung+'REC_VON' );
  sBis := TLocalStorage.GetValue( cFormZeitbuchung+'REC_BIS' );

  iRec_Von := StrToIntDef( sVon  , 1);
  iRec_Bis := StrToIntDef( sBis , frmMainForm.g_RecAnzahl);

  If (iRec_Von=0) or (iRec_Bis=0) then
    Begin
      iRec_Von := 1;
      iRec_Bis := frmMainForm.g_RecAnzahl;
    End;

end;

//====================================================================================================================//

procedure TfrmZeitbuchung.Opt_Speichern;
var sAbf : String;
begin

  sAbf := DateTimeToStr( Trunc( dtFilterDatum.DateTime )   );

  TLocalStorage.SetValue( cFormZeitbuchung+'DATUM_FILTER_EIN', BToS( cbxFilterDatum.Checked ));
  TLocalStorage.SetValue( cFormZeitbuchung+'DATUM_FILTER', sAbf );

  console.Log( cFormZeitbuchung+' >> OptSpeichern '+  IntToStr(iRec_Von)+' / '+  IntToStr(iRec_Bis) );

  TLocalStorage.SetValue( cFormZeitbuchung+'ID_AKT', IntToStr(self.iID_Akt) );
  TLocalStorage.SetValue( cFormZeitbuchung+'REC_VON', IntToStr(self.iRec_Von) );
  TLocalStorage.SetValue( cFormZeitbuchung+'REC_BIS', IntToStr(self.iRec_Bis) );

end;

//====================================================================================================================//

procedure TfrmZeitbuchung.Daten_Laden( aID : Integer );
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sFelder, sSQL, sTmp, sTauStati, sKopfZeile: String;
    aSL_Daten, aSL : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz : Integer;
    dtAbf : TDateTime;
    aArray : TArray<string>;
begin

  If not WaitMessage.Showing then WaitMessage.Show;

  btnNavInfo.Enabled := False;

  aSL_Daten := TStringList.Create;
  aSL := TStringList.Create;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  // Zeitbuchungen ermitteln
  //
  sSQL := '01: SELECT B.ID_ZBUCHUNG, B.ID_ANWABW, B.ZEITSTEMPEL, A.BEZEICHNUNG AS GRUND, A.FARBE '
         +'  FROM ZBUCHUNG B, ANWABW A WHERE B.ID_ANWABW=A.ID_ANWABW '
         +'  AND ID_MITARBEITER ='+ frmMainForm.BenutzerMaNr ;

    If cbxFilterDatum.Checked then
      Begin
        dtAbf := Trunc(dtFilterDatum.DateTime);
        sSQL := sSQL +' AND B.ZEITSTEMPEL >= '+cH+FormatDateTime('dd.mm.yyyy',dtAbf)+cH
                     +' AND B.ZEITSTEMPEL < ' +cH+FormatDateTime('dd.mm.yyyy',dtAbf+1)+cH;
      End;

    sSQL := sSQL + ' ORDER BY B.ZEITSTEMPEL DESC ' +';'  ;

    sSQL := await(  Crypt( sSQL )  );

    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL, iRec_Von, iRec_Bis ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;

  ClientConn.Free;

  aSL_Daten.Text := await( Crypt( sDaten ));

  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

  tabZBuchung.Close;
  tabZBuchung.Open;

  sKopfZeile := aSL[0];
  aArray := sKopfZeile.Split([';']);
  btnNavInfo.Text := aArray[3]+'-'+aArray[4]+' ['+aArray[2]+']';

  If aSL.Count > 2 then
    Begin
      sFelder := aSL[1];
      For i := 2 to aSL.Count -1 Do
        Begin
          sDaten  := aSL[i];
          tabZBuchung.Append;
            tabZBuchung.FieldByName('ID_ZBUCHUNG').AsInteger := SToI(GetFeldWert( sFelder, sDaten, 'ID_ZBUCHUNG' ));
            tabZBuchung.FieldByName('ID_ANWABW').AsInteger   := SToI(GetFeldWert( sFelder, sDaten, 'ID_ANWABW' ));
            tabZBuchung.FieldByName('ZEITSTEMPEL').AsString  := GetFeldWert( sFelder, sDaten, 'ZEITSTEMPEL'   );
            tabZBuchung.FieldByName('GRUND').AsString := GetFeldWert( sFelder, sDaten, 'GRUND' );

            sTmp :=  GetFeldWert( sFelder, sDaten, 'FARBE' );
            If sTmp = '' then sTmp := '$00DFFFFF';
            tabZBuchung.FieldByName('FARBE').AsString := sTmp;

          tabZBuchung.Post;
        End;
    End;

  aSL.Free;
  aSL_Daten.Free;

  If aID = 0 then tabZBuchung.First;
  If aID > 0 then
    If not tabZBuchung.Locate('ID_ZBUCHUNG',aID,[]) then tabZBuchung.First;

  btnNavNext.Enabled := (tabZBuchung.RecordCount=frmMainForm.g_RecAnzahl );
  btnNavInfo.Enabled := True;

  ErzeugeItems;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmZeitbuchung.Do_DatenLaden(Sender: TObject);
begin

  If Sender = btnNavNext then
    Begin
     iRec_Von := iRec_Von + frmMainForm.g_RecAnzahl;
    End
  Else
    Begin
     iRec_Von := iRec_Von - frmMainForm.g_RecAnzahl;
     If iRec_Von < 1 then iRec_Von := 1;
    End;
  iRec_Bis := iRec_Von + frmMainForm.g_RecAnzahl-1;

  Daten_Laden(0);

end;

//====================================================================================================================//

procedure TfrmZeitbuchung.dtFilterDatumChange(Sender: TObject);
var iID : Integer;
begin

  If (Sender=dtFilterDatum) and (cbxFilterDatum.Checked=False) then Exit;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;

  iID := 0;

  Daten_Laden(iID);

end;

//====================================================================================================================//

procedure TfrmZeitbuchung.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  console.log('TfrmTau.OnClose');

  Opt_Speichern;

end;

//====================================================================================================================//

procedure TfrmZeitbuchung.WebFormCreate(Sender: TObject);
begin

  //Console.Log('WebFormCreate----'+IntToStr( frmMainForm.g_RecAnzahl)) ;

  bFirst := False;

  iRec_Von := 1;
  iRec_Bis := frmMainForm.g_RecAnzahl;


  If Application.IsMobile then
       dtFilterDatum.Width := 95
  Else dtFilterDatum.Width := 130;


  btnNavPrev.BitmapContainer := frmMainForm.BitmapCont;
  btnNavNext.BitmapContainer := frmMainForm.BitmapCont;

  Opt_Laden;

end;

//====================================================================================================================//

procedure TfrmZeitbuchung.WebFormShow(Sender: TObject);
begin

  WaitMessage.Show;

  Daten_Laden( self.iID_Akt );

end;

//====================================================================================================================//

procedure TfrmZeitbuchung.respGridItemDblClick(Sender: TObject; Index: Integer);
var aItem : TResponsiveGridItem;

//  procedure AfterCreate(AForm: TObject);
//  begin
//    if Assigned(frmTauEdit) and (frmTauEdit is TfrmTauEdit) then
//      Begin
//         frmTauEdit.iID_Sprache := frmMainForm.iID_Sprache;
//         frmTauEdit.iID_Tau := aItem.Tag;
//         self.iID_Akt       := aItem.Tag;
//
//        frmTauEdit.Sprach_Daten_Laden('TAUEDIT', frmMainForm.iID_Sprache );
//
//         console.log('respGridItemDblClick: ' +IntToStr(iID_Akt) );
//      End;
//  end;

begin

  aItem := respGrid.Items[Index] ;

  self.iID_Akt := aItem.Tag;

  Opt_Speichern;

  //DoTourEdit( aItem.Tag );


end;

//====================================================================================================================//
//
//procedure TfrmTau.SprachDaten_Laden( aID_Sprache : Integer =0 );
//var Response: TXDataClientResponse;
//    ClientConn: TXDataWebClient;
//    Blob: JSValue;
//    sDaten, sSQL, sTmp : String;
//    aSL : TStringList;
//    aStream : TStream;
//    i : Integer;
//    aArray : TArray<string>;
//begin
//
//  If not WaitMessage.Showing then WaitMessage.Show;
//
//  ClientConn := TXDataWebClient.Create(nil);
//  ClientConn.Connection := frmMainForm.XDataConn;
//    Response := await( ClientConn.RawInvokeAsync('ISystemService.GetSprachDaten', ['TAU',aID_Sprache] ) );
//    Blob := Response.Result;
//    asm sDaten = await Blob.text(); end;
//  ClientConn.Free;
//
//  aSL := TStringList.Create;
//  aSL.Text := await( Crypt( sDaten)) ;
//
//  console.Log(  aSL.Text  );
//
//  tabSprachDaten.Close;
//  tabSprachDaten.Open;
//
//  If aSL.Count > 2 then
//    For i := 2 to aSL.Count -1 Do
//        Begin
//         sTmp := aSL[i];
//          aArray := sTmp.Split([';']);
//          tabSprachDaten.Append;
//          tabSprachDaten.FieldByName('NUMMER').AsInteger     := StrToIntDef(aArray[0],0);
//          tabSprachDaten.FieldByName('BEGRIFF').AsString  := aArray[1];
//          tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  := aArray[2];
//          console.Log( 'SprachDaten_Laden: ' + tabSprachDaten.FieldByName('BEGRIFF').AsString +' ' +  tabSprachDaten.FieldByName('BEGRIFF_UEB').AsString  );
//
//          tabSprachDaten.Post;
//        End;
//
//  aSL.Free;
//
//  Form_Uebersetzen;
//
//  WaitMessage.Hide;
//
//end;

//====================================================================================================================//

procedure TfrmZeitbuchung.Form_Uebersetzen;
begin


  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmTau -> NICHT OFFFEN');
     Exit;
    End;

  console.Log( 'Form_Uebersetzen in TfrmTau');

  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

  console.Log( 'Form_Uebersetzen in TfrmTau3: '+tabSprachDatenBEGRIFF_UEB.AsString);

  self.bUebersetzt := True;


end;

//====================================================================================================================//

procedure TfrmZeitbuchung.ErzeugeItems;
var aItem : TResponsiveGridItem;
    sText : String;
    aColBG, aColVG : TColor;
begin

  respGrid.Items.Clear;

  tabZBuchung.First;
  While not tabZBuchung.eof Do
    Begin
      aColBG := StringToColor( tabZBuchungFARBE.AsString );
      aColVG := GetSchriftFarbe( aColBG );

//      sText := '<p><strong>'+tabZBuchungZEITSTEMPEL.AsString+'</strong> - '+tabZBuchungGRUND.AsString+' - '
//      +'<span style="background-color: '+ColToHtmlCol(aColBG)+'; color: '+ColToHtmlCol(aColVG)+';">'+tabZBuchungGRUND.AsString
//      +'</span><br />'+tabZBuchungGRUND.AsString+'<br />'+tabZBuchungGRUND.AsString+'</p>';

      sText := '<p><strong>'+tabZBuchungZEITSTEMPEL.AsString+'</strong> - '
      +'<span style="background-color: '+ColToHtmlCol(aColBG)+'; color: '+ColToHtmlCol(aColVG)+';">'+tabZBuchungGRUND.AsString
      +'</span></p>';



      aItem := respGrid.Items.Add;
      aItem.HTML := sText;
      aItem.Tag :=  tabZBuchungID_ZBUCHUNG.AsInteger;

      //console.log( inttostr(self.iID_Akt)+' - '+inttostr(tabMaBelegID_MA_BELEG.AsInteger) );

      If tabZBuchungID_ZBUCHUNG.AsInteger = self.iID_Akt then
        Begin
          //Console.Log('iID_AKT '+IntToStr(iID_Akt));
          aItem.Selected := True;
        End;

     tabZBuchung.Next;

    end;

end;


//====================================================================================================================//

procedure TfrmZeitbuchung.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbTau := TLabel.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnNavInfo := TTMSFNCToolBarButton.Create(Self);
  dtFilterDatum := TDateTimePicker.Create(Self);
  cbxFilterDatum := TCheckBox.Create(Self);
  btnKommt := TButton.Create(Self);
  btnGeht := TButton.Create(Self);
  btnGehtP := TButton.Create(Self);
  btnKommtP := TButton.Create(Self);
  respGrid := TResponsiveGrid.Create(Self);
  tabZBuchung := TXDataWebDataSet.Create(Self);
  tabZBuchungID_ZBUCHUNG := TIntegerField.Create(Self);
  tabZBuchungID_ANWABW := TIntegerField.Create(Self);
  tabZBuchungZEITSTEMPEL := TStringField.Create(Self);
  tabZBuchungGRUND := TStringField.Create(Self);
  tabZBuchungFARBE := TStringField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbTau.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnNavInfo.BeforeLoadDFMValues;
  dtFilterDatum.BeforeLoadDFMValues;
  cbxFilterDatum.BeforeLoadDFMValues;
  btnKommt.BeforeLoadDFMValues;
  btnGeht.BeforeLoadDFMValues;
  btnGehtP.BeforeLoadDFMValues;
  btnKommtP.BeforeLoadDFMValues;
  respGrid.BeforeLoadDFMValues;
  BitmapCont.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  tabZBuchung.BeforeLoadDFMValues;
  tabZBuchungID_ZBUCHUNG.BeforeLoadDFMValues;
  tabZBuchungID_ANWABW.BeforeLoadDFMValues;
  tabZBuchungZEITSTEMPEL.BeforeLoadDFMValues;
  tabZBuchungGRUND.BeforeLoadDFMValues;
  tabZBuchungFARBE.BeforeLoadDFMValues;
  try
    Width := 1436;
    Height := 533;
    Color := 16776441;
    FormContainer := 'appcontent';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1436;
    WebPanel1.Height := 185;
    WebPanel1.Align := alTop;
    WebPanel1.BorderColor := 16776441;
    WebPanel1.Color := 16776441;
    WebPanel1.ElementFont := efCSS;
    WebPanel1.TabOrder := 0;
    lbTau.SetParentComponent(WebPanel1);
    lbTau.Name := 'lbTau';
    lbTau.Left := 13;
    lbTau.Top := 2;
    lbTau.Width := 130;
    lbTau.Height := 18;
    lbTau.Caption := 'Zeitbuchungen';
    lbTau.Font.Charset := DEFAULT_CHARSET;
    lbTau.Font.Color := clBlack;
    lbTau.Font.Height := -16;
    lbTau.Font.Name := 'Verdana';
    lbTau.Font.Style := [fsBold];
    lbTau.HeightPercent := 100.000000000000000000;
    lbTau.ParentFont := False;
    lbTau.WidthPercent := 100.000000000000000000;
    btnNavPrev.SetParentComponent(WebPanel1);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 5;
    btnNavPrev.Top := 133;
    btnNavPrev.Width := 65;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 0;
    SetEvent(btnNavPrev, Self, 'OnClick', 'Do_DatenLaden');
    btnNavPrev.Text := '';
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnNavNext.SetParentComponent(WebPanel1);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 181;
    btnNavNext.Top := 133;
    btnNavNext.Width := 65;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 1;
    SetEvent(btnNavNext, Self, 'OnClick', 'Do_DatenLaden');
    btnNavNext.Text := '';
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnNavInfo.SetParentComponent(WebPanel1);
    btnNavInfo.Name := 'btnNavInfo';
    btnNavInfo.Left := 74;
    btnNavInfo.Top := 133;
    btnNavInfo.Width := 103;
    btnNavInfo.Height := 44;
    btnNavInfo.Cursor := crHandPoint;
    btnNavInfo.Hint := 'Daten laden';
    btnNavInfo.ParentDoubleBuffered := False;
    btnNavInfo.DoubleBuffered := True;
    btnNavInfo.Font.Charset := ANSI_CHARSET;
    btnNavInfo.Font.Color := clWindowText;
    btnNavInfo.Font.Height := -13;
    btnNavInfo.Font.Name := 'Verdana';
    btnNavInfo.Font.Style := [];
    btnNavInfo.ParentColor := True;
    btnNavInfo.TabOrder := 2;
    SetEvent(btnNavInfo, Self, 'OnClick', 'btnNavInfoClick');
    btnNavInfo.Text := '1 - 50 [254]';
    btnNavInfo.ControlIndex := 0;
    dtFilterDatum.SetParentComponent(WebPanel1);
    dtFilterDatum.Name := 'dtFilterDatum';
    dtFilterDatum.Left := 252;
    dtFilterDatum.Top := 133;
    dtFilterDatum.Width := 117;
    dtFilterDatum.Height := 44;
    dtFilterDatum.Cursor := crHandPoint;
    dtFilterDatum.BorderStyle := bsSingle;
    dtFilterDatum.ChildOrder := 5;
    dtFilterDatum.Color := 15329769;
    dtFilterDatum.Date := 45767.262767685180000000;
    dtFilterDatum.Role := '';
    dtFilterDatum.ShowSeconds := False;
    dtFilterDatum.Text := '';
    SetEvent(dtFilterDatum, Self, 'OnChange', 'dtFilterDatumChange');
    cbxFilterDatum.SetParentComponent(WebPanel1);
    cbxFilterDatum.Name := 'cbxFilterDatum';
    cbxFilterDatum.Left := 252;
    cbxFilterDatum.Top := 108;
    cbxFilterDatum.Width := 100;
    cbxFilterDatum.Height := 23;
    cbxFilterDatum.Cursor := crHandPoint;
    cbxFilterDatum.Caption := 'Datum';
    cbxFilterDatum.ChildOrder := 6;
    cbxFilterDatum.HeightPercent := 100.000000000000000000;
    cbxFilterDatum.WidthPercent := 100.000000000000000000;
    SetEvent(cbxFilterDatum, Self, 'OnClick', 'dtFilterDatumChange');
    btnKommt.SetParentComponent(WebPanel1);
    btnKommt.Name := 'btnKommt';
    btnKommt.Tag := -1;
    btnKommt.Left := 13;
    btnKommt.Top := 28;
    btnKommt.Width := 90;
    btnKommt.Height := 63;
    btnKommt.Cursor := crHandPoint;
    btnKommt.Caption := 'Kommt';
    btnKommt.Color := 12021811;
    btnKommt.ChildOrder := 6;
    btnKommt.Font.Charset := ANSI_CHARSET;
    btnKommt.Font.Color := clWhite;
    btnKommt.Font.Height := -13;
    btnKommt.Font.Name := 'Verdana';
    btnKommt.Font.Style := [fsBold];
    btnKommt.HeightPercent := 100.000000000000000000;
    btnKommt.ParentFont := False;
    btnKommt.WidthPercent := 100.000000000000000000;
    SetEvent(btnKommt, Self, 'OnClick', 'btnGehtClick');
    btnGeht.SetParentComponent(WebPanel1);
    btnGeht.Name := 'btnGeht';
    btnGeht.Tag := -4;
    btnGeht.Left := 297;
    btnGeht.Top := 28;
    btnGeht.Width := 90;
    btnGeht.Height := 63;
    btnGeht.Cursor := crHandPoint;
    btnGeht.Caption := 'Geht';
    btnGeht.Color := 12021811;
    btnGeht.ChildOrder := 6;
    btnGeht.Font.Charset := ANSI_CHARSET;
    btnGeht.Font.Color := clWhite;
    btnGeht.Font.Height := -13;
    btnGeht.Font.Name := 'Verdana';
    btnGeht.Font.Style := [fsBold];
    btnGeht.HeightPercent := 100.000000000000000000;
    btnGeht.ParentFont := False;
    btnGeht.WidthPercent := 100.000000000000000000;
    SetEvent(btnGeht, Self, 'OnClick', 'btnGehtClick');
    btnGehtP.SetParentComponent(WebPanel1);
    btnGehtP.Name := 'btnGehtP';
    btnGehtP.Tag := -2;
    btnGehtP.Left := 108;
    btnGehtP.Top := 28;
    btnGehtP.Width := 90;
    btnGehtP.Height := 63;
    btnGehtP.Cursor := crHandPoint;
    btnGehtP.Caption := 'Geht P.';
    btnGehtP.Color := 12021811;
    btnGehtP.ChildOrder := 6;
    btnGehtP.Font.Charset := ANSI_CHARSET;
    btnGehtP.Font.Color := clWhite;
    btnGehtP.Font.Height := -13;
    btnGehtP.Font.Name := 'Verdana';
    btnGehtP.Font.Style := [fsBold];
    btnGehtP.HeightPercent := 100.000000000000000000;
    btnGehtP.ParentFont := False;
    btnGehtP.WidthPercent := 100.000000000000000000;
    SetEvent(btnGehtP, Self, 'OnClick', 'btnGehtClick');
    btnKommtP.SetParentComponent(WebPanel1);
    btnKommtP.Name := 'btnKommtP';
    btnKommtP.Tag := -3;
    btnKommtP.Left := 202;
    btnKommtP.Top := 28;
    btnKommtP.Width := 89;
    btnKommtP.Height := 63;
    btnKommtP.Cursor := crHandPoint;
    btnKommtP.Caption := 'Kommt P.';
    btnKommtP.Color := 12021811;
    btnKommtP.ChildOrder := 6;
    btnKommtP.Font.Charset := ANSI_CHARSET;
    btnKommtP.Font.Color := clWhite;
    btnKommtP.Font.Height := -13;
    btnKommtP.Font.Name := 'Verdana';
    btnKommtP.Font.Style := [fsBold];
    btnKommtP.HeightPercent := 100.000000000000000000;
    btnKommtP.ParentFont := False;
    btnKommtP.WidthPercent := 100.000000000000000000;
    SetEvent(btnKommtP, Self, 'OnClick', 'btnGehtClick');
    respGrid.SetParentComponent(Self);
    respGrid.Name := 'respGrid';
    respGrid.Left := 0;
    respGrid.Top := 185;
    respGrid.Width := 1436;
    respGrid.Height := 348;
    respGrid.Cursor := crHandPoint;
    respGrid.ElementClassName := 'respgrid';
    respGrid.HeightStyle := ssAuto;
    respGrid.WidthStyle := ssPercent;
    respGrid.WidthPercent := 90.000000000000000000;
    respGrid.Align := alClient;
    respGrid.ChildOrder := 3;
    respGrid.Font.Charset := ANSI_CHARSET;
    respGrid.Font.Color := clWindowText;
    respGrid.Font.Height := -13;
    respGrid.Font.Name := 'Verdana';
    respGrid.Font.Style := [];
    respGrid.ItemIndex := 0;
    respGrid.Options.ItemClassName := 'respitem';
    respGrid.Options.ItemColor := 16639703;
    respGrid.Options.ItemHeight := 40;
    respGrid.Options.ItemHoverColor := 14811135;
    respGrid.Options.ItemSelectedColor := clBisque;
    respGrid.Options.ItemPadding := 5;
    respGrid.Options.ItemWidthMin := 290;
    respGrid.ParentFont := False;
    SetEvent(respGrid, Self, 'OnItemClick', 'respGridItemDblClick');
    BitmapCont.Left := 423;
    BitmapCont.Top := 34;
    tabSprachDaten.Left := 160;
    tabSprachDaten.Top := 256;
    tabZBuchung.SetParentComponent(Self);
    tabZBuchung.Name := 'tabZBuchung';
    tabZBuchung.Left := 64;
    tabZBuchung.Top := 248;
    tabZBuchungID_ZBUCHUNG.SetParentComponent(tabZBuchung);
    tabZBuchungID_ZBUCHUNG.Name := 'tabZBuchungID_ZBUCHUNG';
    tabZBuchungID_ZBUCHUNG.Alignment := taCenter;
    tabZBuchungID_ZBUCHUNG.DisplayWidth := 6;
    tabZBuchungID_ZBUCHUNG.FieldName := 'ID_ZBUCHUNG';
    tabZBuchungID_ZBUCHUNG.Required := True;
    tabZBuchungID_ANWABW.SetParentComponent(tabZBuchung);
    tabZBuchungID_ANWABW.Name := 'tabZBuchungID_ANWABW';
    tabZBuchungID_ANWABW.FieldName := 'ID_ANWABW';
    tabZBuchungZEITSTEMPEL.SetParentComponent(tabZBuchung);
    tabZBuchungZEITSTEMPEL.Name := 'tabZBuchungZEITSTEMPEL';
    tabZBuchungZEITSTEMPEL.Alignment := taCenter;
    tabZBuchungZEITSTEMPEL.DisplayLabel := 'Datum';
    tabZBuchungZEITSTEMPEL.FieldName := 'ZEITSTEMPEL';
    tabZBuchungGRUND.SetParentComponent(tabZBuchung);
    tabZBuchungGRUND.Name := 'tabZBuchungGRUND';
    tabZBuchungGRUND.Alignment := taCenter;
    tabZBuchungGRUND.DisplayLabel := 'Grund';
    tabZBuchungGRUND.DisplayWidth := 30;
    tabZBuchungGRUND.FieldName := 'GRUND';
    tabZBuchungGRUND.Size := 30;
    tabZBuchungFARBE.SetParentComponent(tabZBuchung);
    tabZBuchungFARBE.Name := 'tabZBuchungFARBE';
    tabZBuchungFARBE.DisplayWidth := 20;
    tabZBuchungFARBE.FieldName := 'FARBE';
  finally
    WebPanel1.AfterLoadDFMValues;
    lbTau.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnNavInfo.AfterLoadDFMValues;
    dtFilterDatum.AfterLoadDFMValues;
    cbxFilterDatum.AfterLoadDFMValues;
    btnKommt.AfterLoadDFMValues;
    btnGeht.AfterLoadDFMValues;
    btnGehtP.AfterLoadDFMValues;
    btnKommtP.AfterLoadDFMValues;
    respGrid.AfterLoadDFMValues;
    BitmapCont.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
    tabZBuchung.AfterLoadDFMValues;
    tabZBuchungID_ZBUCHUNG.AfterLoadDFMValues;
    tabZBuchungID_ANWABW.AfterLoadDFMValues;
    tabZBuchungZEITSTEMPEL.AfterLoadDFMValues;
    tabZBuchungGRUND.AfterLoadDFMValues;
    tabZBuchungFARBE.AfterLoadDFMValues;
  end;
end;

end.

